import {Component, Input, OnInit} from '@angular/core';
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {TranslateService} from "@ngx-translate/core";
import {QuestionContentComponent} from "./question-content/question-content.component";
import {PropertyService} from '../forms/services/property.service';

@Component({
    selector: 'app-question-button',
    templateUrl: './question-button.component.html',
    styleUrls: ['./question-button.component.scss'],
    standalone: true,
    providers: [DialogService]
})
export class QuestionButtonComponent implements OnInit {

    @Input() key!: string;
    @Input() questionEdit!: boolean;
    @Input() visibility!: boolean;

    ref!: DynamicDialogRef;

    constructor(public dialogService: DialogService,
                public translate: TranslateService,
                private propertyService: PropertyService) {
    }

    ngOnInit(): void {
    }

    showInfo() {


        this.ref = this.dialogService.open(QuestionContentComponent, {
            header: "",
            width: '400px',
            height: '250px',
            maximizable: true,

            data: {
                key: this.key,
                isAdmin: this.questionEdit
            },
        });
        this.ref.onClose.subscribe(value => {

        });
    }

}
